import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetError } from "./collectionSlice";

export const domain = `https://bird-sounds-database.intelligent.by/`;


export const createUser = createAsyncThunk(
  'auth/createUser',
  async (values, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(domain + `api/user-create/`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify(values)
      })
      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message);
      }
      dispatch(resetError());
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

// export const checkUser = createAsyncThunk(
//   'auth/checkuser',
//   async (values, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await fetch(domain + `api/check-user/`, {
//         method: 'POST',
//         headers: {
//           "Content-Type": "application/json", 
//         },
//         body: JSON.stringify(values)
//       })
//       if (!response.ok) {
//         const errorMessage = await response.json();
//         throw new Error(errorMessage.message);
//       }
//       // dispatch(resetError());
//       const data = await response.json();
//       console.log("in userCheck FUNCTION in authSlice.js!");
//       console.log(data);
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.message)
//     } 
//   }
// );

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (values, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(domain + `api/login-api/`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify(values)
      })

      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message);
      }
      dispatch(resetError())
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);
export const checkAuth = createAsyncThunk(
  'auth/chekAuth',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      var token = `${localStorage.getItem('token')}`;
      var email = `${localStorage.getItem('email')}`;
      var google = `${localStorage.getItem('google')}`;

      if (token==='null' || !`${localStorage.getItem('token')}`) {
        return rejectWithValue("Authentication is needed");
      } else {
        if (google === 'true') {
          console.log(email);
          var myUser = {
            "account": [], 
            "email": email, 
            "is_staff": false
          };

          return myUser;
        }
      };

      const response = await fetch(domain + `api/account/`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })      
      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.non_field_errors);
      }
      dispatch(resetError());
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue, dispatch }) => {
    const token = {
      refresh: localStorage.getItem('refreshToken')
    }
    if (localStorage.getItem('google') === 'true'){
      return {'message':'Successfully logout.'};
    }
    try {
      const response = await fetch(domain + `api/logout/`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json", 
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(token)
      })
      
      if (!response.ok) {
        if (response.status === 401) {
    
          dispatch(setAuthStatus(false));
        }
        const errorMessage = await response.json();
        throw new Error(errorMessage.non_field_errors);
      }
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

export const refreshToken = createAsyncThunk(
  'auth/refreshToken',
  async (_, { rejectWithValue }) => {
    const token = {
      refresh: localStorage.getItem('refreshToken')
    }
    try {
      const response = await fetch(domain + `api/api/refresh-token/`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json", 
        },
        body: JSON.stringify(token)
      })
      
      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.non_field_errors);
      }
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

export const addPhoto = createAsyncThunk(
  'auth/addPhoto',
  async (photo, { rejectWithValue, dispatch }) => {
    const formData = new FormData();
    formData.append('profile_pic', photo)
    try {
      const response = await fetch(domain + `api/account/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: formData,
      })      
      if (!response.ok) {
        if (response.status === 401) {
    
          dispatch(setAuthStatus(false));
        }
        const errorMessage = await response.json();
        throw new Error(errorMessage.non_field_errors);
      }
      const data = await response.json()
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    email: null,
    password: null,
    isAuth: null,
    is_staff: false,
    error: null,
    statusLogin: null,
    statusCreate: null,
    statusCheck: null,
    avatarUrl: null    
  },
  reducers: {
    setAuthStatus: (state, action) => {
      state.isAuth = action.payload;
    },
    resetAuthError: (state) => {
      state.error = null
    }, 
    googleLoginHelper: (state, action) => {
      state.statusLogin = 'succeeded';
      state.email = action.payload.user.email;
      state.is_staff = false;
      localStorage.setItem('token', action.payload.token.access);
      localStorage.setItem('refreshToken', action.payload.token.refresh);
      localStorage.setItem('email', action.payload.user.email);
      localStorage.setItem('google', 'true');
      
      state.isAuth = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.statusLogin = 'loading';
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.statusLogin = 'succeeded';
        state.email = action.payload.user.email;
        state.is_staff = action.payload.user.is_staff;
        localStorage.setItem('token', action.payload.token.access);
        localStorage.setItem('refreshToken', action.payload.token.refresh);
        localStorage.setItem('email', action.payload.user.email);
        localStorage.setItem('google', 'false')
        try {
          state.avatarUrl = action.payload.user.account[0].profile_pic;
        } catch (error) {
          console.error(error);
        }
        state.isAuth = true;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.statusLogin = 'failed';
        state.error = action.payload;
      })
      // .addCase(checkUser.pending, (state) => {
      //   state.statusLogin = 'loading';
      // })
      // .addCase(checkUser.fulfilled, (state, action) => {
      //   state.statusLogin = 'succeeded';
      //   state.is_staff = action.payload.user.is_staff;
      //   localStorage.setItem('token', action.payload.token.access);
      //   localStorage.setItem('refreshToken', action.payload.token.refresh);
      //   localStorage.setItem('email', action.payload.user.email);
      //   try {
      //     state.avatarUrl = action.payload.user.account[0].profile_pic;
      //   } catch (error) {
      //     console.error(error);
      //   }
      //   state.isAuth = true;
      // })

      .addCase(createUser.pending, (state) => {
        state.statusCreate = 'loading';
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.statusCreate = 'succeeded';
        localStorage.setItem('token', action.payload.token.access);
        localStorage.setItem('refreshToken', action.payload.token.refresh);
        localStorage.setItem('email', action.payload.user.email);
        localStorage.setItem('google', 'false');
        state.email = action.payload.user.email;
        state.isAuth = true;
        state.is_staff = action.payload.user.is_staff;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.statusCreate = 'failed';
        state.error = action.payload;
      })
      
      .addCase(logout.pending, (state) => {
        
      })
      .addCase(logout.fulfilled, (state, action) => {        
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('email');
        localStorage.removeItem('language');
        localStorage.removeItem('google');
        state.email = null;        
        state.avatarUrl = null
        state.isAuth = false;
        state.is_staff = false
      })
      .addCase(logout.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(checkAuth.pending, (state) => {
        
      })
      .addCase(checkAuth.fulfilled, (state, action) => {
        try {
          state.avatarUrl = action.payload.account[0].profile_pic;
        } catch (error) {
          console.log(error);
        }
        state.email = action.payload.email;
        state.isAuth = true;
        state.is_staff = action.payload.is_staff
      })
      .addCase(checkAuth.rejected, (state, action) => {
        state.error = action.payload;
        state.isAuth = false;
      })

      .addCase(addPhoto.fulfilled, (state, action) => {        
        state.avatarUrl = action.payload.profile_pic;
      })
      .addCase(addPhoto.rejected, (state, action) => {
        state.error = action.payload;
      })
  }
})
export const { setAuthStatus, resetAuthError, googleLoginHelper } = authSlice.actions;

export default authSlice.reducer